import * as React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import "./all.sass";
import useSiteMetadata from "./SiteMetadata";
import ico from "../img/favicon.ico";
import favicon16 from "../img/favicon-16x16.png";
import favicon32 from "../img/favicon-32x32.png";
import "@fontsource/forum"
import "@fontsource/source-sans-pro"
import "@fontsource/source-sans-pro/300.css"

const TemplateWrapper = ({ children }) => {
  const { title, description } = useSiteMetadata();
  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{title}</title>
        <meta name="description" content={description} />

        <link
          rel="shortcut icon"
          type="image/x-icon"
          href={ico}
        />
        <link
          rel="icon"
          type="image/png"
          href={favicon16}
          sizes="16x16"
        />
        <link
          rel="icon"
          type="image/png"
          href={favicon32}
          sizes="32x32"
        />
        <meta name="theme-color" content="#fff" />

        <meta property="og:type" content="business.business" />
        <meta property="og:title" content={title} />
        <meta property="og:url" content="/" />
      </Helmet>
      <Navbar />
      <div>{children}</div>
      <Footer />
    </div>
  );
};

export default TemplateWrapper;
